<div class="modal-header">
  <strong class="modal-title">PDF Viewer</strong>
</div>
<div class="modal-body">
  <div class="row pdf-content">
    <div class="col-12" *ngIf="innerHTML" [innerHTML]="innerHTML">
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default border float-right app-btn" (click)="modal.close('Close click')">ปิด</button>
</div>
